import {
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Cancel, History, HomeWork, InfoOutlined, Send, Update } from "@material-ui/icons";
import InfoIcon from "@material-ui/icons/Info";
import * as React from "react";
import {
  AutocompleteInput,
  Button,
  CheckboxGroupInput,
  Confirm,
  NumberInput,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  Toolbar,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { ExperienceNoteType } from "../../../../Enums/ExperienceNoteType";
import { RequestType } from "../../../../Enums/RequestType";
import {
  LocalRepairChoices,
  OffWingChoices,
  PnSelectionChoices,
  ReleaseTypeChoices,
  RequestTypeChoices,
} from "../../Constant/Source";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import LocalRepairWarningDialog from "../LocalRepairWarningDialog";
import LocalRepairStatusChip from "../LocalRepairStatusChip";
import { useAuth } from "@airborne/react-admin";
import { useAppDataProvider } from "./../../../../dataprovider";
import { connect } from "react-redux";
import { PBH_REQUEST_UPDATE_CLOSE, PBH_REQUEST_UPDATE_OPEN } from "../../../../Redux/actions";
import { PbhRequestFileType } from "../../../../Enums/PbhRequestFileType";
import { PbhRequestStatus } from "../../../../Enums/PbhRequestStatus";
import { RemarkTypes } from "../../../../Enums/RemarkTypes";
import PbhRequestUpdateHistory from "./PbhRequestUpdateHistory";
import AarStorageSelectForm from "./AarStorageSelectForm";
import { OwnerType, OwnerTypeDesc } from "../../../../Enums/OwnerTypes";
import { ComponentTypesChoices } from "../../../../Enums/ComponentTypes";
import { SSMTypeChoices } from "../../../../Enums/SsmTypes";
import InformationLabel from "../../../../Components/InformationLabel/InformationLabel";
import { useEffect } from "react";
import { useLocalRepairCheck } from "../../../../Helper/useLocalRepairCheck";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const PbhRequestOrderUpdate = props => {
  const { user } = useAuth();
  const notify = useNotify();
  const dataProvider = useAppDataProvider();

  const disabledStatusList: any = [PbhRequestStatus.Cancelled];

  const { isLocalRepair: localRepairApiResult } = useLocalRepairCheck(
    props?.selectedData?.ownerCode,
    props?.selectedData?.pn,
    props?.selectedData?.isLocalRepair === true
  );

  const [loading, setLoading] = React.useState(false);
  const [sendingToCms, setSendingToCms] = React.useState(false);
  const [historyOpen, setHistoryOpen] = React.useState(false);
  const [isCmsVisible, setIsCmsVisible] = React.useState(props?.selectedData?.isCmsVisible);
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [isUpdated, setIsUpdated] = React.useState(false);

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  const handleSendToCmsDashboard = async () => {
    setSendingToCms(true);
    try {
      await dataProvider.put(`pbhrequestorders/${props?.selectedData?.id}/toggle-cms-visibility`);
      const newValue = !isCmsVisible;
      setIsCmsVisible(newValue);
      const message = newValue
        ? "Record sent to CMS Dashboard successfully"
        : "Record excluded from CMS Dashboard successfully";
      notify(message, "success", false, true);
    } catch (error) {
      notify(`Error: ${error}`, "error", false, true);
    } finally {
      setSendingToCms(false);
      setConfirmOpen(false);
    }
  };

  useEffect(() => {
    if (!user?.isCustomer && !disabledStatusList.some(x => x == props?.selectedData?.requestStatus)) {
      let isExistFile = props?.selectedData?.pbhRequestOrderFiles?.some(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Info &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.Defect
      );
      if (isExistFile) {
        notify("You should check the DEFECT document in this record.", "warning", false, false, 5000);
      }
    }
    //ComponentUnmount
    return () => props.updateClose();
  }, []);

  const handleSubmit = async model => {
    var requiredFileCheck = props?.files?.some?.(x => x.pbhRequestFileTypeEnum == PbhRequestFileType.Mailings);
    if (!requiredFileCheck && !user?.isCustomer) {
      notify("Please upload a file of type Mailings.", "warning", false, true);
      return;
    }

    // If the user is a customer and Customer Remark can be updated,
    // update it first before updating the order info.
    if (user?.isCustomer) {
      const canUpdateCustomerRemark =
        props.selectedData?.isRejectionOrder &&
        (props.selectedData?.requestStatus == PbhRequestStatus.Open ||
          props.selectedData?.requestStatus == PbhRequestStatus.UnshippedSvc);

      if (canUpdateCustomerRemark) {
        handleUpdateCustomerRemark({
          ...model.pbhRequestCustomerRemark,
          ...{ requestId: model.id, statusCode: model.requestStatus },
        });
      }
    }

    setLoading(true);
    model.releaseType = model.releaseType.toString();
    model.requirementCategoryText = props?.selectedData?.requirementCategoryList?.find(
      x => x.id == model?.requirementCategory
    )?.category;
    setIsUpdated(true);

    dataProvider
      .updatePbhRequestOrder(model)
      .then(_ => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        props.updateClose();
        location.reload();
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };
  const handleUpdateCustomerRemark = model => {
    const remarkModel = {
      requestId: model.requestId,
      statusCode: model.statusCode,
      remark: model.remark,
      remarkTypeCode: RemarkTypes[RemarkTypes.CustomerFirstRemark],
      remarkType: RemarkTypes.CustomerFirstRemark,
      isCustomer: true,
    };
    dataProvider
      .createPbhRequestRemarks(remarkModel)
      .then(response => {
        props?.finalCallBack?.();
        notify(`Record Updated`, "success", false, true);
        props.updateClose();
      })
      .catch(error => {
        console.error(error);
      });
  };

  const customerPoDisabled = (): boolean => {
    if (!props.isPbhRequestInfoUpdate || props.isPageDisabled) {
      return true;
    }

    if (user?.isCustomer) {
      const isEditableForCustomer =
        props.selectedData?.isRejectionOrder &&
        (props.selectedData?.requestStatus === PbhRequestStatus.Open ||
          props.selectedData?.requestStatus === PbhRequestStatus.UnshippedSvc);

      return !isEditableForCustomer;
    }

    return false;
  };

  const requirementCategoryDisabled = (): boolean => {
    var isDisabled = props.isPageDisabled || !props.isPbhRequestInfoUpdate || (user?.isCustomer ?? false);
    return isDisabled;
  };
  const remarkOfCustomerDisabled = (): boolean => {
    var isDisabled = props.isPageDisabled || !user?.isCustomer || !props.isPbhRequestInfoUpdate;
    return isDisabled;
  };
  const toolbarVisible = () => {
    return !disabledStatusList.some(x => x == props?.selectedData?.requestStatus);
  };
  const customRequired = message => value => (value || !user?.isCustomer ? undefined : message);
  const validateField = value => {
    return customRequired(
      "If any, remarks about the order itself should be explained such as ‘Rejection order due to corrosion’"
    )(value);
  };

  const requirementCategoryChangeEvent = form => e => {
    let requirementCategoryId = e.target.value;
    let selectedRequirementCategory = props.selectedData?.requirementCategoryList.filter(
      rq => rq.id === requirementCategoryId
    )[0];
    form.change("requestedDeliveryDate", selectedRequirementCategory?.calculatedRDD);
  };

  const airportCodeChangeEvent = form => async selectedAirportCode => {
    const customerId = props?.selectedData?.customerId;
    if (!selectedAirportCode || !customerId) {
      return;
    }
    try {
      const response = await dataProvider.getShippingAddressByAirportAndCustomer(selectedAirportCode, customerId);
      if (response?.data?.length > 0) {
        const shippingAddressRecord = response.data[0];
        form.change("attentionName", shippingAddressRecord.attentionName);
        form.change("attentionPhone", shippingAddressRecord.attentionPhone);
        form.change("shippingAddress", shippingAddressRecord.shipAddress);
        form.change("consigneeName", shippingAddressRecord.consigneeName);
        form.change("consigneeAddress", shippingAddressRecord.consigneeAddress);
        form.change("email", shippingAddressRecord.email);
      } else {
        form.change("attentionName", undefined);
        form.change("attentionPhone", undefined);
        form.change("shippingAddress", undefined);
        form.change("consigneeName", undefined);
        form.change("consigneeAddress", undefined);
        form.change("email", undefined);
        notify("Shipping address record not found for the selected airport code.", "warning", false, true);
      }
    } catch (error) {
      console.error(error);
      notify(`Error: ${error}`, "error", false, true);
    }
  };

  const openEditableFields = () => props.updateOpen();
  const cancelUpdate = () => props.updateClose();

  return (
    <>
      <Form
        initialValues={{
          ...props?.selectedData,
          ...{
            releaseType: props?.selectedData?.releaseType?.split(","),
            isLocalRepair: props?.selectedData?.isLocalRepair ?? false,
          },
        }}
        onSubmit={handleSubmit}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Contract Info" />
                    <Grid {...gridContainerProps}>
                      <InformationLabel data={props?.selectedData} />
                    </Grid>
                  </Grid>
                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="contract.contractName"
                        label="Contract"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <RadioButtonGroupInput
                        source="requestType"
                        label="Request Type"
                        fullWidth
                        defaultValue={Number(RequestType.PBH)}
                        choices={RequestTypeChoices}
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Order Info" />
                  </Grid>
                  <Grid {...gridContainerProps} alignItems={"flex-start"}>
                    <Grid item xs={12} sm={5}>
                      <RadioButtonGroupInput
                        source="isPreDefined"
                        label="PN Selection"
                        fullWidth
                        choices={PnSelectionChoices}
                        variant="outlined"
                        disabled
                      />
                      {((!user?.isCustomer &&
                        values.ownerCode == OwnerTypeDesc.find(x => x.Value == OwnerType.SSM)?.Description) ||
                        user?.ownerCode == OwnerTypeDesc.find(x => x.Value == OwnerType.SSM)?.Description) && (
                        <>
                          <RadioButtonGroupInput
                            source="componentType"
                            label="Component Type"
                            fullWidth
                            choices={ComponentTypesChoices}
                            variant="outlined"
                            disabled
                          />
                          <NumberInput source="quantity" label="Quantity" fullWidth variant="outlined" disabled />
                          <SelectInput
                            source="ssmType"
                            label="Type"
                            optionText="Description"
                            optionValue="Value"
                            fullWidth
                            resettable
                            choices={SSMTypeChoices}
                            variant="outlined"
                            disabled
                          />
                        </>
                      )}

                      {(props?.selectedData?.isLocalRepair === true || localRepairApiResult) && (
                        <>
                          <LocalRepairStatusChip
                            initialValue={props?.selectedData?.isLocalRepair || localRepairApiResult}
                          />
                          <RadioButtonGroupInput
                            source="isLocalRepair"
                            label="Local Repair"
                            fullWidth
                            choices={LocalRepairChoices}
                            variant="outlined"
                            disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                          />
                        </>
                      )}
                      <TextInput source="pn" label="Requested Part Number" fullWidth disabled variant="outlined" />

                      <TextInput
                        source="pnDescription"
                        label="Component Description"
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                      <TextInput source="usedSn" label="Used SN" fullWidth disabled variant="outlined" />
                      <TextInput source="unserviceablePn" label="Core Unit PN" fullWidth disabled variant="outlined" />
                      <TextInput source="unserviceableSn" label="Core Unit SN" fullWidth disabled variant="outlined" />
                      <TextInput
                        source="pnDifferenceRemark"
                        label="Pn Difference Remark"
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                      <TextInput source="melCategory" label="Mel Category" fullWidth disabled variant="outlined" />
                      <CustomDatetime
                        fullWidth
                        disabled
                        source="melDueDate"
                        label="Mel Due Date"
                        inputVariant={"dialog"}
                        variant="outlined"
                        showTime
                      />
                      <TextInput
                        source="defectReason"
                        label="Defect Reason"
                        multiline
                        resettable
                        fullWidth
                        rows={3}
                        variant="outlined"
                        disabled
                      />

                      <Chip
                        key={props?.selectedData?.id + "_access"}
                        size="medium"
                        style={{ color: "#767676" }}
                        variant="outlined"
                        label={`Access: ${props?.selectedData?.access ?? "N/A"}`}
                        icon={<InfoIcon />}
                      />
                      <Chip
                        key={props?.selectedData?.id + "_repair"}
                        style={{ margin: "14px", color: "#767676" }}
                        size="medium"
                        variant="outlined"
                        label={`Repair: ${props?.selectedData?.repair ?? "N/A"}`}
                        icon={<InfoIcon />}
                      />
                      {user?.isCustomer !== true && (
                        <Chip
                          key={props?.selectedData?.id + "_in_stock"}
                          size="medium"
                          style={{ color: "#767676" }}
                          variant="outlined"
                          label={`In Stock: ${props?.selectedData?.inStock === true ? "Yes" : "No"}`}
                          icon={<HomeWork />}
                        />
                      )}
                      <RadioButtonGroupInput
                        source="offWing"
                        label="Off Wing"
                        fullWidth
                        choices={OffWingChoices}
                        variant="outlined"
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <NumberInput source="ataChapter" label="Ata Chapter" fullWidth variant="outlined" disabled />
                      <TextInput source="aircraft.acReg" label="Aircraft" fullWidth disabled variant="outlined" />
                      {!isUpdated && (
                        <CheckboxGroupInput
                          source="releaseType"
                          choices={ReleaseTypeChoices()}
                          validate={required()}
                          disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                          variant="outlined"
                        />
                      )}
                      <ReferenceInput
                        label="Airport Code"
                        source="airportCode"
                        reference="cdmlocations"
                        translateChoice={false}
                        filterToQuery={searchText => ({ id__contains: searchText })}
                        sort={{ field: "id", order: "ASC" }}
                        onChange={airportCodeChangeEvent(form)}
                      >
                        <AutocompleteInput
                          optionText="id"
                          optionValue="id"
                          variant="outlined"
                          resettable
                          fullWidth
                          validate={props.isPbhRequestInfoUpdate ? required() : undefined}
                          disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                        />
                      </ReferenceInput>

                      <TextInput source="refNo" label="REF NO" variant="outlined" fullWidth disabled />
                      <Grid container spacing={2}>
                        <Grid item xs={8} sm={9}>
                          <TextInput
                            source="customerPo"
                            label="Customer PO/RO"
                            fullWidth
                            variant="outlined"
                            disabled={customerPoDisabled()}
                          />
                        </Grid>
                        <Grid item xs={4} sm={3}>
                          <TextInput
                            source="customerPoLine"
                            label="Line"
                            variant="outlined"
                            fullWidth
                            disabled={customerPoDisabled()}
                          />
                        </Grid>
                      </Grid>
                      {props?.selectedData?.requestedDeliveryDateDifference !== "" && (
                        <Chip
                          key={9999990}
                          color="primary"
                          variant="outlined"
                          label={props?.selectedData?.requestedDeliveryDateDifference}
                          icon={<InfoOutlined />}
                        />
                      )}
                      <CustomDatetime
                        fullWidth
                        disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                        source="requestedDeliveryDate"
                        label="Requested Delivery Date"
                        inputVariant={"dialog"}
                        variant="outlined"
                        showTime
                      />
                      <SelectInput
                        disabled={requirementCategoryDisabled()}
                        source="requirementCategory"
                        choices={props?.selectedData?.requirementCategoryList}
                        optionText="category"
                        optionValue="id"
                        fullWidth
                        variant="outlined"
                        onChange={requirementCategoryChangeEvent(form)}
                        validate={!requirementCategoryDisabled() ? required() : undefined}
                      />
                      <TextInput
                        source="pbhRequestCustomerRemark.remark"
                        label="Remarks of Customer"
                        multiline
                        fullWidth
                        rows={3}
                        variant="outlined"
                        disabled={remarkOfCustomerDisabled()}
                        FormHelperTextProps={{ style: { display: "block", color: "#c80c0f" } }}
                        validate={validateField}
                      />

                      {user?.isCustomer !== true && (
                        <TextInput
                          source="poolScopeRejectRemark"
                          label="Pool Scope Reject Remark"
                          variant="outlined"
                          fullWidth
                          disabled
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Delivery To" />
                  </Grid>
                  <Grid {...gridContainerProps} alignItems={"flex-start"}>
                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="attentionName"
                        label="Attention Name"
                        fullWidth
                        variant="outlined"
                        validate={props.isPbhRequestInfoUpdate ? required() : undefined}
                        disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                      />
                      <TextInput
                        source="attentionPhone"
                        label="Attention Phone"
                        fullWidth
                        variant="outlined"
                        validate={props.isPbhRequestInfoUpdate ? required() : undefined}
                        disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                      />
                      <TextInput
                        source="shippingAddress"
                        label="Shipping Address"
                        multiline
                        fullWidth
                        rows={3}
                        variant="outlined"
                        validate={props.isPbhRequestInfoUpdate ? required() : undefined}
                        disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <TextInput
                        source="consigneeName"
                        label="Company/Consignee Name"
                        fullWidth
                        variant="outlined"
                        validate={props.isPbhRequestInfoUpdate ? required() : undefined}
                        disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                      />
                      <TextInput
                        source="consigneeAddress"
                        label="Company/Consignee Address"
                        fullWidth
                        variant="outlined"
                        validate={props.isPbhRequestInfoUpdate ? required() : undefined}
                        disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                      />
                      <TextInput
                        source="email"
                        label="E-Mail"
                        fullWidth
                        variant="outlined"
                        validate={props.isPbhRequestInfoUpdate ? required() : undefined}
                        disabled={props.isPageDisabled || !props.isPbhRequestInfoUpdate || user?.isCustomer}
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    {toolbarVisible() && (
                      <Toolbar {...props} placeholder="" classes={classes}>
                        {props.isPbhRequestInfoUpdate === false ? (
                          <>
                            <Button
                              label="Edit"
                              size="medium"
                              variant="contained"
                              onClick={openEditableFields}
                              disabled={props.isPageDisabled}
                              style={{ margin: "8px", background: "#ffc107" }}
                            >
                              {<Update />}
                            </Button>
                            {user?.isCustomer === false && (
                              <Button
                                label="View Update History"
                                size="medium"
                                variant="contained"
                                onClick={() => setHistoryOpen(true)}
                                style={{ margin: "8px", background: "#343a40", color: "white" }}
                              >
                                {<History />}
                              </Button>
                            )}
                            {user?.isCustomer === false && (
                              <>
                                <Button
                                  label={
                                    sendingToCms
                                      ? "Processing..."
                                      : isCmsVisible
                                        ? "Exclude from CMS Dashboard"
                                        : "Send to CMS Dashboard"
                                  }
                                  size="medium"
                                  variant="contained"
                                  onClick={() => setConfirmOpen(true)}
                                  disabled={props.isPageDisabled || sendingToCms}
                                  style={{ margin: "8px", background: "#17a2b8", color: "white" }}
                                >
                                  {sendingToCms ? <CircularProgress size="1.5rem" color="inherit" /> : <Send />}
                                </Button>
                                <Confirm
                                  isOpen={confirmOpen}
                                  loading={sendingToCms}
                                  title="Are you sure?"
                                  content={
                                    isCmsVisible
                                      ? "This record will be excluded from CMS Dashboard."
                                      : "This record will be sent to CMS Dashboard."
                                  }
                                  confirm="Yes"
                                  cancel="No"
                                  onConfirm={handleSendToCmsDashboard}
                                  onClose={() => setConfirmOpen(false)}
                                />
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <Button
                              label={loading ? "Updating!" : "Update"}
                              disabled={props.isPageDisabled || loading}
                              size="medium"
                              variant="contained"
                              onClick={handleSubmit}
                            >
                              {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                            </Button>
                            <Button
                              label={loading ? "Cancel!" : "Cancel "}
                              disabled={
                                props.isPageDisabled ||
                                loading ||
                                props?.selectedData?.requestStatus === PbhRequestStatus.Cancelled
                              }
                              size="medium"
                              variant="contained"
                              color="primary"
                              onClick={cancelUpdate}
                              style={{ margin: "8px" }}
                            >
                              {<Cancel />}
                            </Button>
                          </>
                        )}
                      </Toolbar>
                    )}
                  </Grid>

                  <Grid {...gridContainerProps} alignItems={"flex-start"}>
                    <Grid item xs={12} sm={12}>
                      <AarStorageSelectForm
                        form={form}
                        gridContainerProps={gridContainerProps}
                        useStyles={useStyles}
                        selectedData={props?.selectedData}
                      />
                    </Grid>
                  </Grid>
                </>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <Dialog open={historyOpen} onClose={() => setHistoryOpen(false)} fullWidth maxWidth="xl">
        <DialogTitle>Update History</DialogTitle>
        <DialogContent>
          <PbhRequestUpdateHistory {...props} />
        </DialogContent>
        <DialogActions>
          <Button label="Close" size="medium" variant="contained" onClick={() => setHistoryOpen(false)}>
            {<Cancel />}
          </Button>
        </DialogActions>
      </Dialog>
      <ExperienceSoftWarningDialog data={props?.selectedData?.experience} type={ExperienceNoteType.Info} />
      {!user?.isCustomer && <LocalRepairWarningDialog isLocalRepair={props?.selectedData?.isLocalRepair} />}
    </>
  );
};

const mapStateToProps = state => ({
  files: state.pbhFiles.files,
  isPbhRequestInfoUpdate: state.pbhRequestInfoUpdate.isUpdate,
});
const mapDispatchToProps = dispatch => ({
  updateClose: () => dispatch({ type: PBH_REQUEST_UPDATE_CLOSE }),
  updateOpen: () => dispatch({ type: PBH_REQUEST_UPDATE_OPEN }),
});
// export default PbhRequestOrderUpdate;
export default connect(mapStateToProps, mapDispatchToProps)(PbhRequestOrderUpdate);
